import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { map } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass, AsyncPipe, NgIf } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Environment } from '../../interfaces/environment.interface';
import { LanguageSelectComponent } from '../language-select/language-select.component';

@Component({
  selector: 'wm-libs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [NgIf, MatToolbarModule, NgClass, RouterLink, RouterLinkActive, AsyncPipe, TranslateModule, LanguageSelectComponent],
})
export class FooterComponent {
  @Input() useExternalLinks = false;
  @Input() env!: Environment;
  @Input() accessToken = false;
  currentYear: number;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]).pipe(map((result) => result.matches));

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Large]).pipe(map((result) => result.matches));
  constructor(private breakpointObserver: BreakpointObserver) {
    this.currentYear = new Date().getFullYear();
  }
}
